import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShareService } from '@nttp/common-service/share-service';
import { AddBeneficiaryStep } from '@pg-app/client/manage-recipient/constants/add-beneficiary-constant';
import { AddRecipientFrom } from '@pg-app/client/manage-recipient/constants/add-recipient-constants';
import { NewRecipientModel } from '@pg-app/client/manage-recipient/models/recipient.model';
import { BeneficiarySourceEnum } from '@pg-app/shared/enums/beneficiary-source.enum';

@Component({
  selector: 'np-new-recipient-from-payment',
  templateUrl: './add-new-recipient-from-payment.component.html',
})
export class AddNewRecipientFromSendPaymentComponent implements OnInit, OnDestroy {
  action = AddRecipientFrom.SendPayment;
  addBeneficiaryStep = AddBeneficiaryStep;
  remitterRequired: boolean;
  beneficiarySource: BeneficiarySourceEnum;

  constructor(
    public newRecipientModel: NewRecipientModel,
    private shareService: ShareService
  ) { }

  ngOnInit() {
    this.beneficiarySource = BeneficiarySourceEnum.payment;

    this.getRemitterRequiredConfig();
  }

  ngOnDestroy() {
    this.newRecipientModel.clear();
  }

  getRemitterRequiredConfig() {
    this.shareService.getAccountType(true).subscribe(res => {
      this.remitterRequired = res.fullRemitterDetailsRequired;
    });
  }
}
